import { FileText } from "lucide-react";
import { LAB_REPORT } from "../../config/site";
import { Reveal } from "../motion/Reveal";

const Metric = ({ label, value }) => (
  <div className="border-t border-[#B18A4A]/40 pt-4">
    <p className="text-[10px] font-bold uppercase tracking-[0.26em] text-[#8C6A3C]">{label}</p>
    <p className="font-serif-lux mt-1 text-4xl text-[#26231F]">{value}</p>
  </div>
);

// Renders only when LAB_REPORT.published is true in config/site.js.
export const LabResults = () => {
  const r = LAB_REPORT;
  if (!r?.published) return null;
  const minerals = Array.isArray(r.minerals) ? r.minerals : [];
  return (
    <Reveal className="relative mx-auto mt-20 max-w-[1440px] px-5 sm:px-8 lg:px-12" data-testid="lab-results-panel">
      <div className="bg-[#F8F3E9] p-8 shadow-[0_30px_80px_-40px_rgba(33,23,15,.45)] sm:p-12">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow">Accredited lab results</p>
            <p className="mt-3 text-sm text-[#746D64]">{[r.labName, r.reportRef, r.reportDate].filter(Boolean).join(" · ")}</p>
          </div>
          {r.reportUrl && (
            <a href={r.reportUrl} target="_blank" rel="noreferrer" className="btn-line-dark" data-testid="lab-report-link"><FileText className="h-4 w-4" /><span>View report</span></a>
          )}
        </div>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {r.ph && <Metric label="pH" value={r.ph} />}
          {r.tds && <Metric label="TDS" value={r.tds} />}
          {minerals.map((m) => <Metric key={m.name} label={m.name} value={m.value} />)}
        </div>
      </div>
    </Reveal>
  );
};
